import request from '@/router/axios';
const urlPrefix = '/biz'
const urlInvoicePrefix = '/fsp-invoice'

// 获取雇员工资单明细
export function getSlaryInfo(obj){
  return request({
    url: urlPrefix + '/userPayroll/getSlaryInfo',
    method: 'post',
    data: obj
  })
}

// 下载工资条
export function downPayrollEncl(obj){
  return request({
    url: urlPrefix + '/userPayroll/downPayrollEncl',
    method: 'post',
    responseType: 'arraybuffer',
    data: obj
  })
}

// 验证地址栏携带的参数是否可以访问
export function censorPayrollReq(obj){
  return request({
    url: urlPrefix + '/userPayroll/censorPayrollReq',
    method: 'post',
    data: obj
  })
}

// 验证输入的身份证号
export function checkEmpInfo(obj){
  return request({
    url: urlPrefix + '/userPayroll/checkEmpInfo',
    method: 'post',
    data: obj
  })
}


// 基础表预览工资单
export function getBaseSlaryInfo(obj) {
  return request({
    url:urlPrefix+ '/userPayroll/getBaseSlaryInfo',
    method: 'post',
    data: obj
  })
}

//打包下载工资单
export function packDownloadPayEncl(obj){
  return request({
    url: urlPrefix+'/userPayroll/packDownloadPayEncl',
    method: 'post',
    responseType: 'arraybuffer',
    data: obj
  })
}

export function getReceiptInfo(data) {
  return request({
    url: urlInvoicePrefix + '/ignore-auth/invoice-e-ticket/receipt-preview',
    method: 'post',
    data
  })
}